import { useEffect, useState } from 'react';
import api from '../lib/apiClient';
import { applyThemeColors } from '../utils/colorShades';
import { applyFavicon } from '../utils/favicon';

// Shared by every pre-authentication page (Login, Forgot/Reset Password) —
// each needs the org's app name/icon and must apply the custom theme
// colors/favicon itself, since ConfigProvider (which does the same for the
// authenticated app) only mounts after login.
export interface PublicBranding {
  app_name: string;
  app_icon_url: string | null;
  theme_primary_color: string;
  theme_accent_color: string;
  google_sso_enabled: boolean;
  microsoft_sso_enabled: boolean;
}

export const DEFAULT_PUBLIC_BRANDING: PublicBranding = {
  app_name: 'VNPF One',
  app_icon_url: null,
  theme_primary_color: '#3f7a29',
  theme_accent_color: '#f8991c',
  google_sso_enabled: false,
  microsoft_sso_enabled: false,
};

export function usePublicBranding(): PublicBranding {
  const [branding, setBranding] = useState<PublicBranding>(DEFAULT_PUBLIC_BRANDING);

  useEffect(() => {
    api
      .get<PublicBranding>('/branding')
      .then(({ data }) => {
        setBranding(data);
        applyThemeColors(data.theme_primary_color, data.theme_accent_color);
        applyFavicon(data.app_icon_url);
      })
      .catch(() => {
        // Keep the defaults if this fails — these pages must still work.
      });
  }, []);

  return branding;
}
